import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShortStringPipe } from './string-short.pipe';


@NgModule({
  declarations: [ ShortStringPipe ],
  exports: [ ShortStringPipe ],
  imports: [ CommonModule ],
})

export class ShortstringModule { }
